module.exports = __webpack_public_path__ + "img/scarmy_bobocoin.gm.e099ffe.png";